import { IFeatureProps } from 'mod/featureV2/interface';
import { IFeatureBanner } from 'mod/featureV2/interface/banner';
import { FeatureBanner as ModFeatureBanner } from 'mod/featureV2/FeatureBanner';
import cn from 'classnames';
import swiperStyles from '@pro/feature/swiper.module.less';
import styles from './index.module.less';

export function FeatureBanner(props: IFeatureProps<IFeatureBanner>): Globals.JSXRenderType {
    return (
        <ModFeatureBanner
            className={cn(styles.banner, swiperStyles.scrollbar)}
            {...props}
        />
    )
}

export default FeatureBanner;